import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Operation } from '../operation/operation';
import { RevisionService } from './revision.service';
import { lookupParam } from '../nav/utils';

@Injectable()
export class RevisionsResolver implements Resolve<Operation> {

  constructor(
    private router: Router,
    private revisionService: RevisionService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Operation | Observable<Operation> | Promise<Operation> {
    return new Promise<Operation>(async (resolve, reject) => {
      
      let operation_id = lookupParam(route, 'operation_id');

      this.revisionService
        .revisions(operation_id)
        .subscribe((operation) => {
          
          if(operation) {
            return resolve(operation);
          }
          else {
            this.router.navigate(['operations']);
            return resolve(null);
          }
        });
    });
  }
}